import { Mode } from 'react-hook-form'

export const FORM_MODE: Mode = 'onTouched'
